module.exports = __webpack_public_path__ + "img/confirma-pago.b663bd32.png";